import { H5 } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";
import { twMerge } from "tailwind-merge";

import { CheckedIcon, UncheckedIcon } from "./CheckIcons";

const SubtotalFreeDeliveryContent = ({
  emptyBasket,
  remainder,
  qualifiesForFreeDelivery,
}: {
  emptyBasket: boolean;
  remainder: string;
  qualifiesForFreeDelivery: boolean;
}) => {
  const highlightClass = emptyBasket ? "" : "text-green-700";
  const boldClass = emptyBasket ? "" : "font-bold ";

  if (qualifiesForFreeDelivery) {
    return (
      <>
        <CheckedIcon className={"text-green-700"} />
        <p className={`col-span-11 font-bold text-green-700`}>
          Your order qualifies for free delivery!
        </p>
      </>
    );
  }

  return (
    <>
      <UncheckedIcon className={highlightClass} />
      <p className={twMerge(`col-span-11`, highlightClass)}>
        Spend <span className={boldClass}>{remainder}</span> more
      </p>
    </>
  );
};

export const SubtotalFreeDeliverySection = ({
  qualifiesForFreeDelivery,
  freeDeliveryRemainder,
  emptyBasket,
}: {
  qualifiesForFreeDelivery: boolean;
  freeDeliveryRemainder: number;
  emptyBasket: boolean;
}) => {
  return (
    <div>
      <H5>FREE DELIVERY BY BASKET SUBTOTAL</H5>
      <div className={`grid grid-cols-12 items-center`}>
        <SubtotalFreeDeliveryContent
          remainder={formatCurrency(freeDeliveryRemainder)}
          emptyBasket={emptyBasket}
          qualifiesForFreeDelivery={qualifiesForFreeDelivery}
        />
      </div>
    </div>
  );
};
